<template>
    <div class="small-text mt-3">
        Последняя сработка:
        <span class="small-text font-weight-medium" v-if="time"> {{ getTime(time) }} </span>
        <span class="small-text font-weight-medium" v-else> сейчас </span>
    </div>
</template>

<script>
import { updateTime } from '@/utils/index';

export default {
    name: "DeviceSensorTime",
    props: {
        time: {
            type: String,
            default: null,
        }
    },
    methods: {
        getTime(time) {
            return updateTime(time);
        }
    },
}
</script>